import { Nav, Navbar, Dropdown, DropdownButton, Button } from 'react-bootstrap';
import { useContext } from "react";
import { AuthContext } from '../context/AuthContext';
import {Link} from 'react-router-dom'

export const NavigationBar = () => {
    const { isLoggedIn, login, logout } = useContext(AuthContext);

    const handleLoginRedirect = () => {
        // Todo
    };
    const handleLogoutRedirect = () => {
        //  Todo
    };

    return (
        <>
            <Navbar bg="primary" variant="dark" className="navbarStyle">
                <a className="wb-anchor" href="https://www.waterboards.ca.gov/"  target="_blank">
                    <img src="./wb_logo.png" width="100%" height="100%" /> 
                </a>
                <Link className="navbar-brand " to="https://www.waterboards.ca.gov/water_issues/programs/sso/" target="_blank" > <h2> Sanitary Sewer System Boundary Submittal Tool </h2>
                    {window.location.hostname.includes('test') && (<span style={{ color: "red", fontWeight: "bold", verticalAlign: "middle" }}> - FOR TESTING ONLY</span>)}
                </Link>
                <div className="w-75">
                   { isLoggedIn ?
                    <a  style={{ marginRight: "10px" }} className="float-right navbar-brand" onClick={isLoggedIn ? logout : login}>
                        <div className="my-fancy-container">
                            <span className='fas fa-sign-out-alt my-icon'></span>
                            <span className="my-text">{isLoggedIn ? 'Logout' : 'Login'}</span>
                        </div>
                    </a>
                    :
                    ""
                   }                   
                    <a href="https://www.waterboards.ca.gov/water_issues/programs/sso/docs/2025/s4l-guide.pdf" target="_blank" style={{ marginRight: "25px" }} className="float-right navbar-brand">
                        <div className="my-fancy-container">
                            <span className='fas fa-question my-icon'></span>
                            <span className="my-text">Help</span>
                        </div>
                    </a>
                    <a href="mailto:DWQ-SanitarySewer@Waterboards.ca.gov?subject=Assistance Needed for S4L Issue" style={{ marginRight: "20px" }} className="float-right navbar-brand" >
                        <div className="my-fancy-container">
                            <span className='fas fa-envelope my-icon'></span>
                            <span className="my-text">Contact Us</span>
                        </div>
                    </a>
                  { isLoggedIn ?
                    <a href="/s4l/editor-home" style={{ marginRight: "20px" }} className="float-right navbar-brand" >
                        <div className="my-fancy-container">
                            <span className='fas fa-solid fa-undo-alt my-icon'></span>
                            <span className="my-text">Start Over</span>
                        </div>
                    </a>
                    :
                    ""
                  }                    

                </div>
            </Navbar>
        </>
    );
};
